(() => {
  const BRHFaqs = () => {
    const init = () => {
      const faqs = document.querySelectorAll(".brh-faqs");

      if (faqs && faqs.length > 0) {
        faqs.forEach((faq) => {
          const accordionToggle = faq.querySelector(".accordion-toggle-JS");

          if (accordionToggle) {
            // Expand all the chosen accordions by default once the page has been loaded
            if (accordionToggle.getAttribute("data-expanded") && accordionToggle.getAttribute("data-expanded") === "active") {
              if (!faq.classList.contains("active")) {
                faq.classList.add("active");
              }
            }
          }
        });
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHFaqs);
})();
